require('./login-template.html');

exports.inject = function(module) {
  module.config(['$routeProvider', function($routeProvider) {
    $routeProvider.when('/login', {
      templateUrl: 'login-template.html',
      controller: 'LoginController',
      loginLayout: true
    });
  }]);
  module.controller('LoginController', ['$scope', '$routeParams',  '$timeout', '$location', 'Auth', '$window', 'gtmJS', exports.controller]);
};

exports.controller = function($scope, $routeParams, $timeout, $location, Auth, $window, gtmJS) {
  if($routeParams.url_auth_token) {
    if (!$window.localStorage.userInfo || $window.localStorage.userInfo == "null") {
      Auth.loginWithUrlAuthToken($routeParams.url_auth_token).then(function() {
        $window.open('/app/#/plans-billing-update' , '_parent');
      });
    } else {
      $window.open('/app/#/plans-billing-update' , '_parent');
    }
  }

  $scope.loginSubmit = function($event, username, password) {
    Auth.login(username, password).then(function() {
      $location.path('/#/dashboard');
      gtmJS.push(gtmJS.events.AUTH_LOGIN);
    }, function(response) {
      if(response.status == 401 && !response.data.success) {
        $scope.errorMessage = "The user name or password you entered is invalid. Try again";
      }
    });
  };
};



/*****************
 ** WEBPACK FOOTER
 ** ./app/authorization/login-controller.js
 ** module id = 299
 ** module chunks = 0
 **/